export const PMAX_BIDDING_STRATEGIES = {
    MAXIMIZE_CONVERSIONS: "Maximize Conversions",
    MAXIMIZE_CONVERSION_VALUE: "Maximize Conversion value",
};
